import { render } from "./HOGCLogo.vue?vue&type=template&id=3f12ad46&scoped=true"
import script from "./HOGCLogo.vue?vue&type=script&lang=js"
export * from "./HOGCLogo.vue?vue&type=script&lang=js"

import "./HOGCLogo.vue?vue&type=style&index=0&id=3f12ad46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f12ad46"]])

export default __exports__